'use client';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import { useEffect, useState } from 'react';
import * as cheerio from 'cheerio';
import { useRouter, useSearchParams } from 'next/navigation';
import { BASE_FILE_URL, BASE_URL, BG_COLORS, COLORS } from '@/common/constants';
import { useTranslations } from 'next-intl';
import { FacebookFilled, LeftOutlined, PrinterOutlined, TagOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import Link from 'next/link';
import { checkAndNormalizeUrls, formatDateVN, replaceImages, slugify, stripHtmlTagsAdvanced } from '@/common/ultils';
import { twMerge } from 'tailwind-merge';
import FeebackPage from '../../../components/TinTucDetailPage/Feebacks';
import RelatedArticles from '../../../components/TinTucDetailPage/RelatedArticles';
import LikeButton from '../../../components/TinTucDetailPage/LikeButton';
import PreViewComponent from '../../../components/TinTucDetailPage/ImagePopupSlideshow';

const cleanHtmlContent = (html) => {
  if (!html) return '';
  const $ = cheerio.load(html);
  // Loại bỏ thẻ html, head, body nếu có
  $('html, head, body').each((i, el) => {
    $(el).replaceWith($(el).html());
  });
  return $.html();
};

export default function ChiTietBaiViet(props) {
  const { slugDetail, menuActive, posts, tags, relatedPosts, websiteCode, locale, deviceType } = props;
  const router = useRouter();
  const t = useTranslations('');

  const searchParams = useSearchParams();

  const titlePage = searchParams.get('page');
  const tc = posts?.menu?.type === 'schedule' ? 'link' : null;
  const showcaseWalls = posts?.showcaseWalls ?? [];
  const [fontSize, setFontSize] = useState(16);
  const [audioUrl, setAudioUrl] = useState(null);
  const [error, setError] = useState(null);

  const handleZoomIn = () => {
    setFontSize((prev) => Math.min(prev + 2, 28));
  };

  const handleZoomOut = () => {
    setFontSize((prev) => Math.max(prev - 2, 10));
  };

  const handleShareFacebook = () => {
    if (typeof window === 'undefined') return;
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(posts.title);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`, '_blank', 'width=600,height=400');
  };
  const transformedContent = (content, posts) => {
    let cleanedContent = cleanHtmlContent(content);
    if (get(posts, 'sharpMedias', [])?.length) {
      const data = replaceImages(cleanedContent, get(posts, 'sharpMedias', []), deviceType);
      return data;
    }
    return cleanedContent;
  };

  async function handleGetLinkTTK(content) {
    try {
      const response = await fetch(`${BASE_URL}/postss/fromTextToSound`, {
        method: 'POST',
        headers: {
          websiteCode: !isEmpty(websiteCode) && websiteCode !== 'undefined' ? websiteCode : null,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ lang: get(posts, 'language.websiteCode', 'vi'), text: content }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const audioBuffer = await response.arrayBuffer();
      const blob = new Blob([audioBuffer], { type: 'audio/mpeg' });
      const url = URL.createObjectURL(blob);

      return url;
    } catch {}
  }

  const handleGenerateAudio = async (content) => {
    if (!content) return;

    setError(null);

    try {
      if (audioUrl) {
        URL.revokeObjectURL(audioUrl);
      }

      const url = await handleGetLinkTTK(stripHtmlTagsAdvanced(content));
      setAudioUrl(url);
    } catch (err) {
      setError(err.message);
    } finally {
    }
  };

  const handlePrint = () => {
    if (typeof window === 'undefined') return;

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const printContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="utf-8">
                <title>In bài viết - ${posts.title}</title>
                <style>
                    body {
                        margin: 20px; 
                        line-height: 1.6;
                        color: #333;
                        font-size: 14px;
                    }
                    h1 { 
                        color: #dc2626; 
                        margin-bottom: 10px; 
                        font-size: 24px;
                        font-weight: bold;
                    }
                    .meta-info {
                        color: #666; 
                        font-size: 12px; 
                        margin-bottom: 20px; 
                        font-style: italic;
                    }
                    .content {
                        font-size: 14px; 
                        margin-bottom: 20px;
                        line-height: 1.8;
                    }
                    .source {
                        text-align: right; 
                        font-weight: bold; 
                        margin-top: 20px;
                    }
                    .source i {
                        font-weight: normal;
                    }
                    @media print {
                        body { margin: 0; }
                        h1 { page-break-after: avoid; }
                    }
                </style>
            </head>
            <body>
                <h1>${posts.title}</h1>
                <div class="meta-info">
                    <p>Ngày đăng: ${!!(posts?.postedDate ?? posts?.date) ? formatDateVN(posts?.postedDate ?? posts?.date) : ''}</p>
                    <p>Tác giả: ${posts.author}</p>
                </div>
                <div class="content">
                    ${cleanHtmlContent(posts.content)}
                </div>
                ${
                  posts?.source?.name ?? posts?.createdBy?.name
                    ? `<p class="source">Nguồn: <i>${posts?.source?.name ?? posts?.createdBy?.name ?? 'admin'}</i></p>`
                    : ''
                }
            </body>
            </html>
        `;

    printWindow.document.write(printContent);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  };

  useEffect(() => {
    if (isUndefined(menuActive?.type) && !isEmpty(posts) && typeof posts.content === 'string') {
      handleGenerateAudio(`${posts.title} ${posts?.content}`);
    }
  }, [posts]);

  function getFileUrl(content) {
    if (!content) {
      return null;
    }

    // Tìm URL có http hoặc https
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = content.match(urlRegex);

    if (match && match.length > 0) {
      return match[0]; // Trả về URL đầu tiên tìm thấy
    }

    // Trường hợp có /uploads/files nhưng không có http
    const uploadIndex = content.indexOf('/uploads/files');

    if (uploadIndex !== -1) {
      return `${BASE_FILE_URL}${content.slice(uploadIndex)}`;
    }
    if (posts?.fileDocuments?.length > 0) {
      return `${BASE_FILE_URL}/${posts?.fileDocuments?.[0]}`; // Trả về URL mặc định nếu không có URL nào trong nội dung
    }
    return null;
  }

  if (!menuActive && !posts) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[500px] text-center px-4">
        <div className="relative">
          <div
            className="absolute -top-10 -left-10 w-20 h-20 bg-gradient-to-br 
                        from-red-100 to-pink-100 rounded-full opacity-60 animate-pulse"></div>
          <div
            className="absolute -bottom-10 -right-10 w-16 h-16 bg-gradient-to-br 
                        from-purple-100 to-blue-100 rounded-full opacity-60 animate-pulse delay-500"></div>
          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-100 p-8 max-w-md mx-auto">
            <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-pink-500 mb-4">404</div>
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-red-400 to-pink-500 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 
                                        012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <p className="text-2xl font-bold text-gray-800 mb-3">{t('home.erorrNotFound')}</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 
                                    hover:to-pink-700 text-white rounded-lg font-medium transition-all duration-200 
                                    transform hover:scale-105 shadow-lg hover:shadow-xl cursor-pointer">
                ← {t('home.back')}
              </button>
              <button
                onClick={() => (window.location.href = '/')}
                className="px-6 py-3 bg-white border-2 border-gray-200 hover:border-gray-300 
                                    text-gray-700 hover:text-gray-900 rounded-lg font-medium transition-all 
                                    duration-200 transform hover:scale-105 hover:shadow-md cursor-pointer">
                🏠 {t('home.hometitle')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isEmpty(posts)) {
    return <div className="container mx-auto  text-left text-gray-500 text-base">{t('news.updateNew')}</div>;
  } else {
    const content = typeof posts.content === 'string' ? posts.content : '';
    return (
      <>
        {tc === 'link' || props.isPostMenu ? null : (
          <div className="bg-gray-200 p-2 mb-2 rounded">
            <Link className="cursor-pointer" href={websiteCode ? `/sub/${websiteCode}` : `/`}>
              {titlePage}
            </Link>
            {titlePage ? '/' : ''}
            <Link className="cursor-pointer" href={websiteCode ? `/sub/${websiteCode}/tin-tuc` : `/tin-tuc`}>
              {t('home.news')}
            </Link>
            {showcaseWalls.length ? '/' : ''}
            {showcaseWalls.map((showcaseWall, index) => (
              <Link
                key={showcaseWall.id}
                className="cursor-pointer"
                href={websiteCode ? `/sub/${websiteCode}/chuyen-muc/${showcaseWall.slug}` : `/chuyen-muc/${showcaseWall.slug}`}>
                {showcaseWall.name}
                {index < showcaseWalls.length - 1 ? ' - ' : ''}
              </Link>
            ))}
          </div>
        )}
        <div className="flex items-start">
          {/* {tc === 'link' && ( */}
          <button
            className={twMerge('mb-2 min-w-8 rounded mr-2 aspect-square flex items-center justify-center', BG_COLORS.greenLight)}
            onClick={() => router.back()}>
            <LeftOutlined className="text-white!" />
          </button>
          {/* )} */}
          <h1 className={twMerge('text-xl md:text-2xl font-bold pb-2', COLORS.primary)}>{posts.title}</h1>
        </div>
        <div className="flex justify-between flex-wrap">
          <div className="flex mt-5">
            {!!posts?.postedDate && (
              <p className="text-sm text-gray-500 font-light italic">
                {t('articleDetail.publishedDate')}:{!!posts?.postedDate ? formatDateVN(posts.postedDate) : ''}
              </p>
            )}
            {/* <p className="text-sm text-gray-500 font-light ml-5 italic">
                      {t('articleDetail.author')}: {posts.author}
                    </p> */}
            <p className={twMerge('text-sm text-gray-500 font-light italic', !!posts?.postedDate ? 'ml-5' : '')}>
              {t('articleDetail.totalView')} : {posts?.views}
            </p>
          </div>
          <div className="flex items-center gap-3 p-3 ">
            <div className="flex items-center gap-2">
              <button
                onClick={handleZoomOut}
                className="flex items-center justify-center w-8 h-8 bg-white 
                                            border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                title="Thu nhỏ">
                <ZoomOutOutlined size={15} className="text-gray-600" />
              </button>
              <span className="text-sm text-gray-600 min-w-[40px] text-center">{fontSize}px</span>
              <button
                onClick={handleZoomIn}
                className="flex items-center justify-center w-8 h-8 bg-white 
                                            border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
                title="Phóng to">
                <ZoomInOutlined size={15} className="text-gray-600" />
              </button>
            </div>
            <div className="h-6 w-px bg-gray-300 mx-2"></div>
            <div className="flex items-center gap-2">
              <button
                onClick={handleShareFacebook}
                className="flex items-center justify-center w-8 h-8 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                title="Chia sẻ Facebook">
                <FacebookFilled size={15} />
              </button>
              <button
                onClick={handlePrint}
                className="flex items-center justify-center w-8 h-8 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                title="In bài viết">
                <PrinterOutlined size={15} />
              </button>
              <LikeButton slug={slugDetail} />
            </div>
          </div>
        </div>
        {tc === 'link' ? null : (
          <div>
            {error && <div style={{ color: 'red' }}>Lỗi: {error}</div>}
            {audioUrl && <audio src={audioUrl} controls style={{ display: 'block', marginTop: '10px' }} />}
          </div>
        )}
        {tc === 'link' ? (
          getFileUrl(content) ? (
            <a href={getFileUrl(content)} target="_blank" rel="noopener noreferrer" className="text-blue-500" style={{ textDecoration: 'underline' }}>
              <div className="mb-5" dangerouslySetInnerHTML={{ __html: cleanHtmlContent(content) }} />
            </a>
          ) : (
            <div className="mb-5" dangerouslySetInnerHTML={{ __html: cleanHtmlContent(content) }} />
          )
        ) : get(posts, 'medias', [])?.length ? (
          <PreViewComponent
            content={transformedContent(content, posts)}
            fontSize={fontSize}
            listImg={checkAndNormalizeUrls(get(posts, 'medias', []))}
          />
        ) : (
          <div
            className="text-md content-articles ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred customeimg "
            style={{ fontSize: `${fontSize}px` }}
            dangerouslySetInnerHTML={{ __html: transformedContent(content, posts) }}
          />
        )}
        <div className="flex flex-wrap">
          {tags.length > 0 && (
            <>
              <TagOutlined className="mr-2" /> <span className="mt-1 mr-2">{t('home.keywords')}</span>
            </>
          )}
          {posts && Array.isArray(posts.tagIds)
            ? tags
                .filter((tag) => posts.tagIds.includes(tag?.id))
                .map((item, idx) => (
                  <span className="rounded-3xl bg-gray-200 pt-1 pb-1 pl-3 pr-3 mr-2" key={idx}>
                    <Link href={`/tim-kiem-tin-tuc?tag=${slugify(item.name.toLowerCase())}`}>{item.name}</Link>
                  </span>
                ))
            : null}
        </div>
        {posts?.source?.name ||
          (posts?.createdBy?.name && (
            <p className="text-right font-bold">
              {t('articleDetail.source')} :<i className="font-light">{posts?.source?.name ?? posts?.createdBy?.name ?? 'admin'}</i>
            </p>
          ))}
        <hr className="mt-2" />

        {get(posts, 'isAllowFeedback', false) && <FeebackPage id={posts?.id} websiteCode={websiteCode} locale={locale} />}
        <br />
        <RelatedArticles relatedPosts={relatedPosts} websiteCode={websiteCode} />
      </>
    );
  }
}
